import { NgModule } from '@angular/core'
import { SidebarFooterComponent } from './sidebar-footer/sidebar-footer.component'
import { SidebarHeaderComponent } from './sidebar-header/sidebar-header.component'
import { SidebarNavBadgePipe } from './sidebar-nav-badge.pipe'
import { SidebarNavDividerComponent } from './sidebar-nav-divider/sidebar-nav-divider.component'
import { SidebarNavGroupService } from './sidebar-nav-group.service'
// import { SidebarNavGroupComponent } from './sidebar-nav-group/sidebar-nav-group.component'
import { SidebarNavIconPipe } from './sidebar-nav-icon.pipe'
import { SidebarNavItemClassPipe } from './sidebar-nav-item-class.pipe'
import { SidebarNavLabelComponent } from './sidebar-nav-label/sidebar-nav-label.component'
import { SidebarNavLinkPipe } from './sidebar-nav-link.pipe'
import { SidebarNavLinkComponent, SidebarNavLinkContentComponent } from './sidebar-nav-link/sidebar-nav-link.component'
import { SidebarNavTitleComponent } from './sidebar-nav-title/sidebar-nav-title.component'
import { SidebarNavHelper } from './sidebar-nav.service'
import { SidebarNavComponent, SidebarNavGroupComponent } from './sidebar-nav/sidebar-nav.component'
import { SidebarToggleDirective } from './sidebar-toggle.directive'
import { SidebarTogglerDirective } from './sidebar-toggler.directive'
import { SidebarService } from './sidebar.service'
import { SidebarComponent } from './sidebar/sidebar.component'
import { SidebarBrandComponent } from './sidebar-brand/sidebar-brand.component'
import { SidebarTrialComponent } from './sidebar-trial/sidebar-trial.component'

@NgModule({
    imports: [
        SidebarComponent,
        SidebarBrandComponent,
        SidebarFooterComponent,
        SidebarHeaderComponent,
        SidebarNavComponent,
        SidebarNavBadgePipe,
        SidebarNavDividerComponent,
        SidebarNavGroupComponent,
        SidebarNavIconPipe,
        SidebarNavItemClassPipe,
        SidebarNavLabelComponent,
        SidebarNavLinkComponent,
        SidebarNavLinkContentComponent,
        SidebarTrialComponent,
        SidebarNavLinkPipe,
        SidebarNavTitleComponent,
        SidebarToggleDirective,
        SidebarTogglerDirective,
    ],
    exports: [
        SidebarComponent,
        SidebarToggleDirective,
        SidebarTogglerDirective,
        SidebarBrandComponent,
        SidebarNavComponent,
        SidebarHeaderComponent,
        SidebarFooterComponent,
        SidebarTrialComponent,
    ],
    providers: [SidebarService, SidebarNavHelper, SidebarNavGroupService],
})
export class SidebarModule {}
